import { render, staticRenderFns } from "./DepotGraph.vue?vue&type=template&id=4965f998&scoped=true"
import script from "./DepotGraph.vue?vue&type=script&lang=js"
export * from "./DepotGraph.vue?vue&type=script&lang=js"
import style0 from "./DepotGraph.vue?vue&type=style&index=0&id=4965f998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4965f998",
  null
  
)

export default component.exports